

























































































































































































































































































































































































import { ICruise } from "@/@types/cruiseOffers/cruiseList";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";

import identity_cards from "@/config/identity/identity_cards";
import GuestSortCruise from "./sorts/guest-sort-cruise.vue";
import CitizenshipsName from "./sorts/citizenships-name.vue";
import { IRoomControl } from "@/@types/hotel/room";

@Component({ components: { cruises: GuestSortCruise, CitizenshipsName } })
export default class GuestSortsSlidebar extends Vue {
  @Prop({ type: String, default: "" }) children!: string;
  @Prop({ type: String, default: "" }) birthday!: string;
  @Prop({ type: String, default: "" }) cruise_code!: string;
  @Prop({ type: String, default: "" }) gender!: string;
  @Prop({ type: String, default: "" }) doc_type!: string;
  @Prop({ type: String, default: "" }) citizenship!: string;
  @Prop({ type: String, default: "" }) room_type!: string;
  @Prop({ type: String, default: "" }) room_level!: string;
  @Prop({ type: Boolean, default: false }) pensioners!: boolean;
  @Prop({ type: Array, default: () => [] }) cruises!: Array<ICruise>;
  @Prop({ type: Array, default: () => [] }) cruiseCodes!: Array<string>;
  @Prop({ type: Array, default: () => [] }) citizenships!: Array<string>;
  @Prop({ type: Array, default: () => [] }) roomLevels!: Array<IRoomControl>;
  @Prop({ type: Array, default: () => [] }) roomTypes!: Array<IRoomControl>;

  childrens = [
    "0-2",
    "0-3",
    "2-5",
    "0-7",
    "7-18",
    "0-14",
    "0-15",
    "15-18",
    "0-18",
  ];
  birthdays = ["today", "during-stay"];
  identity_cards = identity_cards;
  childInput = this.children;
  lastEmittedChildren = this.children;

  onChildInput(value: string): void {
    this.childInput = value;
    this.lastEmittedChildren = value;
    this.$emit("children", value);
    if (this.pensioners) this.$emit("pensioners", false);
  }

  onChildrenClick(value: string): void {
    this.childInput = value;
    this.lastEmittedChildren = value;
    this.$emit("children", value);
    if (this.pensioners) this.$emit("pensioners", false);
  }

  onPensionersClick(): void {
    if (this.pensioners) return;
    this.$emit("pensioners", true);
    if (this.children) this.$emit("children", "");
  }

  get roomType(): IRoomControl | null {
    const type = this.roomTypes.find((t) => t._id === this.room_type);
    return type ? type : null;
  }

  get roomLevel(): IRoomControl | null {
    const level = this.roomLevels.find((l) => l._id === this.room_level);
    return level ? level : null;
  }

  get childrenDropdownText(): string {
    if (!this.childInput)
      return this.$t("Guests.List.sorts.children.group") as string;
    if (this.childrens.includes(this.childInput)) {
      return this.$t(`Guests.List.sorts.children.${this.childInput}`) as string;
    }
    return this.$t("Guests.List.sorts.children.custom.value") as string;
  }

  @Watch("children")
  onChildrenPropChange(newVal: string): void {
    if (newVal === this.lastEmittedChildren) return;
    this.childInput = newVal;
    this.lastEmittedChildren = newVal;
  }

  print(): void {
    window.print();
  }

  onSidebarShown(): void {
    document.addEventListener("click", this.handleDocumentClick);
  }

  onSidebarHidden(): void {
    document.removeEventListener("click", this.handleDocumentClick);
  }

  handleDocumentClick(e: MouseEvent): void {
    const target = e.target as HTMLElement;
    const sidebar = document.getElementById("guest-sorts-slidebar");
    if (!sidebar) return;
    const isOnBackdrop = target.classList.contains("modal-backdrop");
    const isOutsideSidebar = !sidebar.contains(target);
    if (isOnBackdrop || isOutsideSidebar) {
      this.closeSidebar();
    }
  }

  closeSidebar(): void {
    this.$root.$emit("bv::slide::hide", "guest-sorts-slidebar");
  }
}
